import { StorageKey } from 'types/storage/storage-key.enum';

export const setAuthToken = (token: string): void => {
  localStorage.setItem(StorageKey.AuthToken, token);
};
